module.exports = __webpack_public_path__ + "img/main_partner2026.8d5a808e.png";